"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["style"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbsoluteFill = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var AbsoluteFillRefForwarding = function AbsoluteFillRefForwarding(props, ref) {
  var style = props.style,
      other = _objectWithoutProperties(props, _excluded);

  var actualStyle = (0, react_1.useMemo)(function () {
    return _objectSpread({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }, style);
  }, [style]);
  return (0, jsx_runtime_1.jsx)("div", _objectSpread({
    ref: ref,
    style: actualStyle
  }, other));
};
/**
 * An absolutely positioned <div> element with 100% width, height, and a column flex style
 * @link https://www.remotion.dev/docs/absolute-fill
 */


exports.AbsoluteFill = (0, react_1.forwardRef)(AbsoluteFillRefForwarding);